import type { Structure } from '../types/categories';
import { CompType } from '../types/CompType';
import { SectionItemDataType } from '../types/SectionItemDataType';
import { SourceType } from '../types/SourceType';

export class StructureBuilder {
  private structure: Structure = {
    componentType: CompType.CustomElement,
    data: {
      freezeFrame: false,
      metaData: {
        isPreset: false,
        schemaVersion: '1.0',
        isHidden: false,
      },
      sourceType: SourceType.External,
      type: SectionItemDataType.TPAWidget,
      url: '',
    },
    style: '',
    styleId: 'style-id-0',
    design: {},
  };

  build(): Structure {
    return { ...this.structure };
  }
}
